export var getCellStyle = function (plugin, data) {
    return (plugin === null || plugin === void 0 ? void 0 : plugin.cellStyle) ? typeof (plugin === null || plugin === void 0 ? void 0 : plugin.cellStyle) === 'function'
        ? plugin === null || plugin === void 0 ? void 0 : plugin.cellStyle(data) : plugin === null || plugin === void 0 ? void 0 : plugin.cellStyle
        : undefined;
};
//# sourceMappingURL=getCellStyle.js.map